// extracted by mini-css-extract-plugin
export default {"colorBlackSqueeze":"#F2F7FA","unit":"8px","lgBreak":"1440px","coverImageWidth":"956px","hotelCoverImage":"jG_MWFUwcAOOi2KFYLap","noHotelCoverImage":"lIMS3DkgtZARPwDO0OhP"};